import React, { useEffect, useState } from 'react';
import { Input, Modal, ModalBody, ModalHeader } from 'reactstrap';
import PropTypes from 'prop-types';
import Stepper from "react-stepper-horizontal";
import "./Model.css";
import { decryptData } from '../../utils/helper';
import { stageStatusOption } from '../../modules/applications/Constant';
import { createApplicationActivity, getApplicationById, updateApplication } from '../../api/Applications';
import { useConfirmDialog } from '../../hooks/useConfirmDialog';
import Loader from '../Loader/Loader';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { failed, success } from '../../utils/Tostify';
import { ActivityDetails, platformLayout } from '../../utils/constants';

function Model({ className, modal, handleClose, applicationData, refetch }) {
  let token = useSelector((state) => state.userReducer.token);
  let role = localStorage.getItem("userRole");
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [application, setApplication] = useState(applicationData?.childStages);
  const [appStages, setAppStages] = useState([]);
  const [visibleSteps, setVisibleSteps] = useState(0);
  const { getConfirmation } = useConfirmDialog();
  const [middleStage,setMiddleStage]=useState(null);
  const index = applicationData?.index ? applicationData?.index : 1;
  const [activeIndex, setActiveIndex] = useState(index);
  const [previousApplication,setPreviousAplication]=useState(applicationData?.childStages);
    useEffect(() => {
      const currentIndex = appStages.findIndex(stage => stage._id === previousApplication?._id);
      if (currentIndex !== -1) {
        setVisibleSteps(currentIndex);
        setMiddleStage(appStages[currentIndex]);
      }
    }, [appStages, previousApplication]);

    useEffect(() => {
      const activeStepIndex = appStages.findIndex(stage => stage._id === previousApplication?._id);
        if (activeStepIndex !== null && activeStepIndex !== -1) {
            setVisibleSteps(activeStepIndex);
        } else {
            setVisibleSteps(0); // Default to the first step if activeStepIndex is invalid
        }
    }, []);

    const handleNext = () => {
      setVisibleSteps((prev) => {
          if (appStages.length === 0) return prev; // Prevent moving if no stages are present
          const nextStep = Math.min(prev + 1, appStages.length - 1);
          setMiddleStage(appStages[nextStep]);
          setPreviousAplication(appStages[nextStep]);
          setActiveIndex(nextStep+1);
          return nextStep;
      });
  };

  const handlePrev = () => {
      setVisibleSteps((prev) => {
          if (appStages.length === 0) return prev; // Prevent moving if no stages are present
          const prevStep = Math.max(prev - 1, 0);
          setPreviousAplication(appStages[prevStep]);
          setMiddleStage(appStages[prevStep]);
          setActiveIndex(activeIndex-1);
          return prevStep;
      });
  };


  const handleStatusChange = async (stageId, childId, newStatus) => {
    let res;
    try {
        const confirmed = await getConfirmation({
            title: "Attention!",
            entryName: "",
            actionBtnTitle: "Yes",
            message: "Are you sure you want to change the status?"
        });

        if (confirmed) {
            const currentDate = moment().format("MM-DD-YYYY");
            let updatedStages = appStages.map((stage, index) => {
                // Update the current stage
                if (stage._id === middleStage?._id) {
                    const updatedChildren = stage.child.map(child => {
                        if (child._id === childId) {
                            return {
                                ...child,
                                status: newStatus,
                                completionDate: newStatus === "Approved" ? currentDate : null
                            };
                        }
                        return child;
                    });

                    const allChildrenCompleted = updatedChildren.every(child => child.status === "Approved");
                    const someChildInProcess = updatedChildren.some(child => child.status === "InProcess");

                    return {
                        ...stage,
                        status: newStatus === "NotApproved"
                            ? "NotApproved"
                            : allChildrenCompleted
                            ? "Approved"
                            : someChildInProcess
                            ? "InProcess"
                            : stage.status,
                        child: updatedChildren
                    };
                }
                return stage;
            });

            // Get index of the current stage (where the child status was updated)
            const currentStageIndex = appStages.findIndex(s => s._id === middleStage?._id);

            // Forward progress: If all children are approved, move the next stage to 'InProcess'
            if (currentStageIndex >= 0 && currentStageIndex < updatedStages.length - 1) {
                const currentStage = updatedStages[currentStageIndex];
                const allChildrenCompleted = currentStage.child.every(child => child.status === "Approved");

                updatedStages = updatedStages.map((stage, index) => {
                    // Update the next stage (forward progress)
                    if (index === currentStageIndex + 1) {
                        return {
                            ...stage,
                            status: allChildrenCompleted ? "InProcess" : "NotStarted",
                            child: stage.child.map(child => ({
                              ...child,
                              status: "NotStarted"  // Set child status accordingly
                          }))
                        };
                    }
                    // For backward progress: Reset all subsequent stages to "NotStarted"
                    if (index > currentStageIndex) {
                        return {
                            ...stage,
                            status: "NotStarted",
                            child: stage.child.map(child => ({
                                ...child,
                                status: "NotStarted"  // Reset children statuses to NotStarted
                            }))
                        };
                    }
                    return stage;
                });
            }
            const anyStageNotApproved = updatedStages.some(stage => stage.status !== "Approved");
            const anyStageNotInProcess = updatedStages.some(stage => stage.status == "InProcess");
            const allStagesApproved = updatedStages.every(stage => stage.status == "Approved");
            const applicationStatus =  allStagesApproved ? "Approved" : anyStageNotInProcess ? "InProcess" : anyStageNotApproved ? "NotApproved" : "Approved";
            const values = { stages: updatedStages, status: applicationStatus };
            setIsLoading(true);
            res = await updateApplication({ values, dispatch, token, applicationId: applicationData?.application?._id });
            let payload = {
              type : "Application",
              event : ActivityDetails?.StageUpdate.event,
              applicationId : applicationData?.application?._id,
              clinicId: localStorage.getItem("currentHospitalId"),
              organizationId: localStorage.getItem("currentOrgId"),
              patientId : applicationData?.application?.patientData?._id,
              details : ActivityDetails?.StageUpdate.details
            };
            if (res?.status === "SUCCESS") {
                await createApplicationActivity({ values: payload, dispatch, token });
                await getApplication();
                await refetch();
                setIsLoading(false);
                // success(res?.message);
            } else {
                setIsLoading(false);
                failed(res?.message);
            }
        }
    } catch (error) {
        setIsLoading(false);
        failed(error?.message || "An error occurred");
    }
};

  const getApplication = async () => {
    let res;
    try {
      setIsLoading(true);
      res = await getApplicationById({ dispatch, token, applicationId: applicationData?.application?._id });
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        setApplication(responseData.stages.find((stg) => stg?._id === applicationData?.childStages?._id));
        setAppStages(responseData.stages);
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const handleStage = async (status) => {
    const currentDate = moment().format("MM-DD-YYYY");
    let res;
    try {
      const updatedStages = appStages?.map((stage, index, stages) => {
        // Handle the current stage
        if (stage._id === middleStage?._id) {
          let updatedChildren = stage.child;
          // Only update child stages to "Approved" if the main stage is set to "Approved"
          if (status === "Approved") {
            updatedChildren = stage.child.map(child => ({
              ...child,
              status: "Approved",
              completionDate: currentDate
            }));
          }else if(status === "NotApproved"){
            updatedChildren = stage.child.map(child => ({
              ...child,
              status: "NotApproved",
              completionDate: currentDate
            }));
          }
          else if (status === "InProcess") {
            updatedChildren = stage.child.map(child => ({
              ...child,
              status: "InProcess"
            }));
          }
          return {
            ...stage,
            status: status,  // Update the main stage status
            child: updatedChildren // Conditionally update child stages
          };
        }
        // Handle the next stage
        if (status === "Approved" && stages[index - 1]?._id === middleStage?._id) {
          return {
            ...stage,
            status: "InProcess"
          };
        }
        if (status === "InProcess" && index < stages.findIndex(s => s._id === middleStage?._id)) {
          return {
              ...stage,
              status: "Approved",
              child: stage.child.map(child => ({
                  ...child,
                  status: "Approved" // Set child stages to Approved
              }))
          };
      }
        // Handle all subsequent stages for "InProcess"
        if (status === "InProcess" && stages[index - 1]?._id === middleStage?._id) {
          return {
            ...stage,
            status: "NotStarted",
            child: stage.child.map(child => ({
              ...child,
              status: "NotStarted" // Set child stages to NotStarted
            }))
          };
        }
        // // If any step is after the one marked as "InProcess", set it to "NotStarted"
        const currentStageIndex = stages.findIndex(s => s._id === middleStage?._id);
        if (index > currentStageIndex) {
          return {
            ...stage,
            status: "NotStarted",
            child: stage.child.map(child => ({
              ...child,
              status: "NotStarted" // Set child stages to NotStarted
            }))
          };
        }
        return stage;
      });
      const anyStageNotApproved = updatedStages.some(stage => stage.status !== "Approved");
      const anyStageNotInProcess = updatedStages.some(stage => stage.status == "InProcess");
      const allStagesApproved = updatedStages.every(stage => stage.status == "Approved");
      const applicationStatus =  allStagesApproved ? "Approved" : anyStageNotInProcess ? "InProcess" : anyStageNotApproved ? "NotApproved" : "Approved";
      const values = { stages: updatedStages, status : applicationStatus };
      setIsLoading(true);
      res = await updateApplication({ values, dispatch, token, applicationId: applicationData?.application?._id });
      if (res?.status === "SUCCESS") {
        let values = {
          type : "Application",
          event : ActivityDetails?.StageUpdate?.event,
          applicationId : applicationData?.application?._id,
          clinicId: localStorage.getItem("currentHospitalId"),
          organizationId: localStorage.getItem("currentOrgId"),
          patientId : applicationData?.application?.patientData?._id,
          details : ActivityDetails?.StageUpdate?.details
        };
        await createApplicationActivity({ values, dispatch, token });
        await getApplication();
        await refetch();
        setIsLoading(false);
        // success(res?.message);
      } else {
        setIsLoading(false);
        failed(res?.message);
      }
    } catch (error) {
      setIsLoading(false);
      failed(error?.message || "An error occurred");
    }
  };
  useEffect(() => {
    getApplication();
  }, []);

  const statusColors = {
    "NotApproved": "#E44545",   // Red for Rejected
    "InProcess": "#ECB800",  // Yellow for InProcess
    "Approved": "#339900",  // Green for Completed
    "NotStarted": "#8B8D91" // Default Grey for Not Started
  };
  const currentStatus = appStages[visibleSteps]?.status; // Get the current status
  const activeTitleColor = statusColors[currentStatus];

  const getStatusColor = (status) => {
    switch(status) {
      case "InProcess":
        return "#ECB800"; // Yellow
      case "NotApproved":
        return "#E44545"; // Red
      case "Approved":
        return "#339900"; // Green
      case "NotStarted":
        return "#8B8D91"; // Grey
      default:
        return "#8B8D91"; // Default color if no status
    }
  };

  return (
    <div className='stepper_modal'>
      <Modal size='lg' isOpen={modal} toggle={handleClose} className={className}>
        <ModalHeader>
          <div className='d-flex justify-content-between align-items-center'>
            <div>
            <h6>{`${applicationData?.application?.patientData?.name[0].text && decryptData(applicationData?.application?.patientData?.name[0].text)}`}</h6>
            </div>
            <div className='close_poup'>
              <i className="fa fa-close" onClick={handleClose}></i>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          {isLoading && <Loader />}
          <div className='stepper'>
          <div className='d-flex justify-content-between'>
              <button className='stepper-arrow' onClick={handlePrev} disabled={activeIndex === 1}><i className='fas fa-angle-left'></i></button>
              <div className="custom-stepper">
              {appStages.slice(visibleSteps, visibleSteps + 1).map((step, index) => (
                    <div
                        key={index}
                        className={`step-container ${index <= 1 ? "active" : ""}`}
                    >
                        {/* Circle for the step */}
                        <div
                        className={`step-circle ${index === 1 ? "current-step" : ""}`}
                        style={{
                            borderColor: getStatusColor(step?.status),
                            backgroundColor: step?.status === "InProcess" ? "#ECB800" :
                                    step?.status === "NotApproved" ? "#E44545" :
                                    step?.status === "Approved" ? "#339900" :
                                    step?.status === "NotStarted" ? "#8B8D91" : "transparent",
                            color: "#fff"
                        }}
                        >
                        {activeIndex}
                        </div>
                        {/* Title and status button below the circle */}
                        <div className="step-content">
                        <span
                            className="step-title"
                            style={{
                            color: getStatusColor(step?.status)
                            }}
                        >
                            {step?.name}
                        </span>
                        {step?.status && (
                            <button
                            className={`status-button ${step?.status.toLowerCase()}`}
                            style={{
                                backgroundColor: getStatusColor(step?.status)
                            }}
                            >
                            {step?.status.replace(/([A-Z])/g, " $1").trim()}
                            </button>
                        )}
                        </div>
                    </div>
                    ))}
                </div>
              <button className='stepper-arrow' onClick={handleNext}><i className='fas fa-angle-right'></i></button>
            </div>
          </div>
          {/* Display child stages for the middle stage */}
          {middleStage && (
            <div className='child-stages'>
              {middleStage.child?.length > 0 ? <h6>Child Tasks for: {middleStage.name}</h6> : null}
              {middleStage.child.map((child) => (
                <div className='household_data d-flex justify-content-between align-items-center' key={child._id}>
                  <div className='d-flex gap-2 align-items-center'>
                    {child.status === "Approved" ? <i className="fa fa-check"></i> : child.status === "NotStarted" ? <i className="fa fa-check" style={{ backgroundColor: "#8F8F8F" }}></i> : child.status === "NotApproved" ? <i className="fa fa-check" style={{ backgroundColor: "#E44545" }}></i> : <i className="fa fa-check" style={{ backgroundColor: "#ECB800" }}></i>}
                    <p className='task_title m-0'>{child.name}</p>
                  </div>
                  <div className='d-flex align-items-center'>
                    <Input type="select" disabled={middleStage.status ==="NotStarted" || role == platformLayout?.Patient} value={child.status} onChange={(e) => handleStatusChange(middleStage._id, child._id, e.target.value)}>
                      <option value="" disabled>--Select--</option>
                      {stageStatusOption?.map((option, index) => (
                        <option key={index} value={option?.value}>{option?.label}</option>
                      ))}
                    </Input>
                  </div>
                  <p className='task_blk'>{child.completionDate ? "Completed" + moment(child.completionDate).format("MMM-DD-YYYY") : ""}</p>
                </div>
              ))}
            </div>
          )}
          {role !== platformLayout?.Patient && <div className="edit d-flex gap-2 align-items-center justify-content-center mt-3">
              {middleStage && middleStage?.status !== "NotStarted" ? <button className="mark_note" style={{backgroundColor : "#E44545"}} onClick={()=> handleStage("NotApproved")}>Not Approved</button> : null}
              <button className="mark_note" style={{ backgroundColor: (middleStage?.status === "Approved" || middleStage?.status === "NotApproved") ? "#ECB800" : "#339900" }} onClick={()=> middleStage?.status === "InProcess" ? handleStage("Approved") : handleStage("InProcess")}  >{middleStage?.status === "InProcess" ?  "Approved" : "In Progress"}</button>
          </div>}
        </ModalBody>
      </Modal>
    </div>
  );
}

Model.propTypes = {
  className: PropTypes.string,
  modal: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  applicationData: PropTypes.object.isRequired,
  refetch: PropTypes.func
};

export default Model;
